import { client, URL } from "../api/apolloClient";
import { Store } from "../stores";
import { baseWithAllProviders } from "@izi-logistics/common/lib/HOK";

export const withAllProviders = (App) =>
  baseWithAllProviders(App, client, Store, URL);
